import './App.css';
import './GlobalAlert.css';
import Header from './include/Header';
import Footer from './include/Footer';
import Addproduct from './components/Addproduct';
import Updateproduct from './components/Updateproduct';
import Login from './components/Login';
import Register from './components/Register';
import ProtectedRoute from "./components/ProtectedRoute";
import EditProduct from "./components/EditProduct";
import GlobalAlert from './include/GlobalAlert';
import { BrowserRouter, Routes, Route } from 'react-router-dom';


function App() {
  return (
    <div className="App">
   <BrowserRouter>
   {/* <Header /> */}
   <Routes>
     <Route path="/" element={<Register />} />
      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />

      <Route
        path="/addproduct"
        element={
          <ProtectedRoute>
            <Addproduct />
          </ProtectedRoute>
        }
      />

      <Route
        path="/updateproduct"
        element={
          <ProtectedRoute>
            <Updateproduct />
          </ProtectedRoute>
        }
      />
       <Route
  path="/edit-product/:id"
  element={
    <ProtectedRoute>
      <EditProduct />
    </ProtectedRoute>
  }
/>
    </Routes>
  
   <Footer /> 
   
   </BrowserRouter>
        
    </div>
  );
}

export default App;
